import React from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ScenarioBar from "../components/ScenarioBar";
import { ROUTES } from "../utils/constants";

import scenario1Ok from "../assets/bg/scenario-1-ok.png";
import scenario2Ok from "../assets/bg/scenario-2-ok.png";
import scenario3Ok from "../assets/bg/scenario-3-ok.png";
import scenario4Ok from "../assets/bg/scenario-4-ok.png";

const SCENARIO_BACKGROUNDS = {
	2: scenario1Ok,
	3: scenario2Ok,
	4: scenario3Ok,
	5: scenario4Ok,
	6: scenario4Ok,
};

function getRouteForScenario(scenarioNum) {
	if (scenarioNum === 1) return ROUTES.SCENARIO1_INTRO;
	if (scenarioNum === 2) return ROUTES.SCENARIO2;
	if (scenarioNum === 3) return ROUTES.SCENARIO3_INTRO;
	if (scenarioNum === 4) return ROUTES.SCENARIO4_INTRO;
	if (scenarioNum === 5) return ROUTES.SCENARIO5_INTRO;
	if (scenarioNum === 6) return ROUTES.SUPERTEST_INTRO;
	return ROUTES.SCENARIO2_INTRO;
}

function TransitionScenarios({ intl }) {
	const navigate = useNavigate();
	const prevState = useLocation();
	const actualScenario = useSelector((state) => state?.group?.actualScenario);
	const rawActive = prevState?.state?.activeScenario ?? actualScenario;
	const activeScenario = Math.min(Math.max(Number(rawActive) || 0, 2), 6);

	const backgroundImage = SCENARIO_BACKGROUNDS[activeScenario] || SCENARIO_BACKGROUNDS[2];

	const handleGoToScenario = (scenarioNum) => {
		if (scenarioNum !== activeScenario) return;
		navigate(getRouteForScenario(scenarioNum));
	};

	return (
		<div
			className="h-100 d-flex flex-column"
			style={{
				backgroundImage: `url(${backgroundImage})`,
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center 120px",
				backgroundSize: "contain",
			}}
		>
			<div
				className="flex-grow-1"
				role="button"
				tabIndex={0}
				onClick={() => handleGoToScenario(activeScenario)}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						handleGoToScenario(activeScenario);
					}
				}}
				aria-label="Ir al escenario actual"
				style={{ cursor: "pointer" }}
			/>
			<ScenarioBar
				activeScenario={activeScenario}
				onScenarioClick={handleGoToScenario}
			/>
		</div>
	);
}

export default injectIntl(TransitionScenarios);
